import { RaiseText } from "../../raise-components"
import React from "react"

import { Card } from "../../App.styles"
import { useStore } from "../../containers"
import { InfoCell } from "./InfoCell"
import { OkCell } from "./OkCell"

export function DonateStatusCell() {
  const { isAccountCreated, active } = useStore()
  // @FIXME: Substituir RaiseText por CardTitle
  return (
    <Card disabled={!active}>
      <RaiseText
        fontSize="20px"
        fontWeight="600"
        textAlign="center"
        marginBottom="30px">
        Contribuição Online
      </RaiseText>
      {isAccountCreated ? <OkCell /> : <InfoCell />}
    </Card>
  )
}
